import React from 'react';
import '../user/AboutPAPT.css';  // Import the corresponding CSS file for styling

const transport = () => {
  return (
    <div className="about-container">
      <div className="content">
        <h1>SPORTS & FITNESS</h1>
        <div className="yellow-line1"></div>
        <p>
        At PA Polytechnic College, we believe that physical fitness is as important as academic excellence. Our campus boasts well-equipped sports facilities that encourage students to engage in various outdoor and indoor games. We have spacious football and cricket fields, basketball and volleyball courts, and a well-maintained running track to promote overall fitness.

For those interested in indoor activities, we offer table tennis, chess, carrom, and badminton facilities. Our modern gymnasium is equipped with advanced fitness equipment, allowing students to maintain a healthy and active lifestyle.

Regular sports events, inter-college tournaments, and fitness programs are organized to nurture teamwork, leadership, and discipline among students. With dedicated coaches and trainers, we ensure that every student has an opportunity to enhance their physical strength, endurance, and mental well-being through sports and fitness activities. and faculty.
        </p>
       
      </div>
      <div className="ed">
        <img src="/images/gym.jpg" />
      </div>
    </div>
  );
};

export default transport;
